module.exports = __webpack_public_path__ + "img/icon_project01.b322f9ea.png";